<template>
  <div v-if="workflowDefinition">
    <!-- Vue mount component but props is undefined -->
    <div>
      <RawJsonToggler :json="workflowDefinition" />
      <!-- Workflow Definition -->
      <h1>{{ workflowDefinition.name }}</h1>
      <!-- Actions -->
      <div>
        <h3>Actions</h3>
      </div>
      <DataList :data="workflowDefinition" :attributes="attributes" />
      <!-- Tasks -->
      <DataTable
        caption="Tasks"
        :rowKeys="['taskReferenceName']"
        :rows="workflowDefinition.tasks"
        :columns="[
          { name: 'name', type: 'text' },
          { name: 'taskReferenceName', type: 'text' },
          { name: 'type', type: 'text' }
        ]"
      />
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import DataList from '@/components/DataList.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'

export default {
  name: 'EmbedWorkflowDefinition',
  props: ['workflowDefinition'],
  data() {
    return {
      attributes: [
        { name: 'name', type: 'text' },
        { name: 'description', type: 'text' },
        { name: 'version', type: 'text' },
        { name: 'createTime', type: 'date' }
      ]
    }
  },
  components: {
    DataList,
    DataTable,
    RawJsonToggler
  }
}
</script>
